import request from "@/utils/request.js";

// 图形验证码校验通过后，发送短信验证码
export function loginPhoneSendCode(params) {
  return request({
    url: "/userService/api/app/user/nurse/login/loginPhoneSendCode",
    method: "post",
    data: params,
  });
}

// 手机号+验证码登录（不存在即注册）
export function loginPhoneVerifyCode(params) {
  return request({
    url: "/userService/api/app/user/nurse/login/loginPhoneVerifyCode",
    method: "post",
    data: params,
  });
}
